import store from '../../store';
export default function setRecords(entity, records) {
    let recordsToSet;
    if (!Array.isArray(records)) {
        recordsToSet = [records];
        throw console.warn('records were passed as object into setRecord function');
    }
    else {
        recordsToSet = records;
    }
    return store.commit(entity + '/SET_LIST', recordsToSet);
}
